import { Notification } from './useNotifications'

import React from 'react'

import { Box } from '@mui/material'
import Modal from 'components/Atoms/Modal/Modal'
import { B2 } from 'components/Atoms/Text/Text'
import { RoundedBtn } from 'components/Buttons/RoundedBtn/RoundedBtn'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

interface NotificationPopupModalProps {
  open: boolean
  notification: Notification | null
  onClose: () => void
}

const NotificationPopupModal: React.FC<NotificationPopupModalProps> = ({
  open,
  notification,
  onClose,
}) => {
  const navigate = useNavigate()
  const { t } = useTranslation('global')

  const handleClose = () => {
    onClose()
  }

  const extractPath = (url: string): string => {
    // Si ya viene como path (empieza con /), usarlo directamente
    if (url.startsWith('/')) {
      return url
    }

    // Si viene como URL completa, extraer solo el path
    try {
      const urlObj = new URL(url)
      return urlObj.pathname
    } catch {
      // Si no se puede parsear como URL, asumir que es un path y devolverlo
      return url.startsWith('/') ? url : `/${url}`
    }
  }

  const handleShowMore = () => {
    // Marcar como leída antes de navegar
    onClose()

    if (notification?.action) {
      const path = extractPath(notification.action)
      navigate(path)
    }
  }

  if (!notification) {
    return null
  }

  return (
    <Modal open={open} setOpen={() => handleClose()} title={notification.title}>
      <Box sx={{ mb: 2 }}>
        {notification.image_url && (
          <Box
            component='img'
            src={notification.image_url}
            alt='Notification image'
            sx={{
              maxWidth: '100%',
              maxHeight: '200px',
              objectFit: 'contain',
              mb: 2,
            }}
          />
        )}
        <B2>{notification.description}</B2>
        {notification.content && (
          <B2 color='#8D949A'>{notification.content}</B2>
        )}
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, gap: 2 }}>
        <RoundedBtn fx={handleClose} type='secondary' label={t('btn.close')} />
        {notification.action && (
          <RoundedBtn
            fx={handleShowMore}
            type='primary'
            label={t('btn.view_more')}
          />
        )}
      </Box>
    </Modal>
  )
}

export default NotificationPopupModal
